import React from "react";
import { UserMenu, MenuItemLink, Logout } from "react-admin";
import PersonIcon from "@mui/icons-material/Person";

const CustomUserMenu = (props) => {
  return (
    <UserMenu {...props}>
      <MenuItemLink
        to="/my-profile"
        primaryText="マイページ"
        leftIcon={<PersonIcon />}
      />
      <Logout />
    </UserMenu>
  );
};

export default CustomUserMenu;
